/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * User preferred locale for emails and notifications
 */
export enum UserLocale {
  en = 'en',
  fr = 'fr'
}
